module.exports = __webpack_public_path__ + "img/bg_decor.3bcb50b5.png";